const defaultState = {
  show: false,
};

// eslint-disable-next-line default-param-last
export default function loading(state = defaultState, action) {
  switch (action.type) {
    case 'SHOW_LOAD':
      return {
        ...state,
        show: true,
      };

    case 'HIDE_LOAD':
      return {
        ...state,
        show: false,
      };

    default:
      return {
        ...state,
      };
  }
}
